import React, { useState, useEffect } from 'react';

export const StepFive = (props) => {
    const [data, setData] = useState({
        place: props.data.place,
        cost: props.data.cost,
        detail: props.data.detail,
        mustCompare: props.data.mustCompare,
        ubication: props.data.ubication,
        date: props.data.date,
        sector: props.data.sector,
        idSubType: props.data.idSubType,
        spot: props.data.spot,
    })

    const handleChange = (prop, value) => {
        setData((prevState) => ({
            ...prevState,
            [prop]: value, 
        }));
    }

    useEffect((props) => { 
        props.updateStepData('five', data)
    }, [data])

    return(
            <div style={{padding:50}}>
                <div className="mt-6 border-t border-gray-100">
                    <dl className="divide-y divide-gray-100">
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Lugar
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            value={data.spot}
                                            onChange={(e) => {handleChange('spot', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Sector
                                    </label>
                                    <div className="mt-2">
                                        <select
                                            value={data.sector}
                                            onChange={(e) => {handleChange('sector', e.target.value)}}
                                            id="location"
                                            name="location"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        >
                                            <option value={null}>SELECCIONAR</option>
                                            {
                                                props.sector.map((sector) => {
                                                        return(
                                                            <option key={sector.id} value={sector.id}>{sector.value}</option>
                                                        )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Tipo de Multa
                                    </label>
                                    <div className="mt-2">
                                        <select
                                            value={data.idSubType}
                                            onChange={(e) => {handleChange('idSubType', e.target.value)}}
                                            id="location"
                                            name="location"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        >
                                            <option value={null}>SELECCIONAR</option>
                                            <option value={1}>ACCIDENTE DE TRÁNSITO</option>
                                            <option value={2}>INFRACCIÓN AMBIENTAL</option>
                                            <option value={3}>INFRACCIÓN DE TRÁNSITO</option>
                                            <option value={4}>OTRA</option>
                                        </select>
                                    </div>
                                </div>
                            </dd>
                        </div>
                        <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                                <div>
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Especifique incidente
                                    </label>
                                    <div className="mt-2">
                                        <textarea
                                            value={data.detail}
                                            onChange={(e) => {handleChange('detail', e.target.value)}}
                                            id="email"
                                            name="email"
                                            type="textarea"
                                            placeholder=""
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
    )
}